import React, { Component } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import i18n from 'app/common/lib/i18n';
import intersection from 'lodash/intersection';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyButton from 'app/common/react/ui/deprecated/LegacyButton';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import listItemsAnd from 'app/common/lib/react/concatList';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import PropTypes from 'prop-types';
import templateConst from 'app/common/lib/templateConst';
import { interpolateNamedTemplate } from 'app/common/lib/react/interpolate';
import { unfollow as unfollowBoard } from 'app/common/redux/actions/board/follow';
import { unfollow as unfollowUser } from 'app/common/redux/actions/user/follow';
import UserBlock, {
  getUserNames,
} from 'app/common/react/components/undiscovery/UserBlock/UserBlock';
import {
  blockUser,
  leaveBoard,
} from 'app/common/react/components/undiscovery/BlockAndUnfollow/blockAndUnfollowUtils';
import { FlagType, Status } from 'app/common/react/components/undiscovery/UndiscoveryEnums';

const HELP_BLOCKING_URL = templateConst.settings.HELP_BLOCKING;
const ABOUT_ACCEPTABLE_USE = templateConst.settings.ABOUT_ACCEPTABLE_USE;

const Actions = {
  LEAVE_AND_UNFOLLOW_BOARD: 'leaveAndUnfollowBoard',
  LEAVE_BOARD_AND_BLOCK_PINNER: 'leaveBoardAndBlockPinner',
};

function renderBlockUnfollowRadio(options) {
  const { type, labelText, labelDescription, handleRadioUpdate } = options;

  return (
    <label
      className="blockAndUnfollowFormLabel"
      htmlFor={type}
      onChange={handleRadioUpdate}
      key={type}
    >
      <input id={type} name="action" type="radio" value={type} />
      <div className="flagReasonRadioButtonOuter">
        <div className="flagReasonRadioButtonInner" />
      </div>
      <div className="labelWrapper">
        {labelText}
        <span className="labelDescription">{labelDescription}</span>
      </div>
    </label>
  );
}

function renderBlockUnfollowCheckbox(options) {
  const { id, value, labelText, labelDescription, handler } = options;

  return (
    <label className="blockAndUnfollowFormLabel" htmlFor={id} onChange={handler} key={id}>
      <input id={id} name="action" type="checkbox" value={value} />
      <span className="uncheckedBox">{'\u2610'}</span>
      <span className="checkedBox">{'\u2611'}</span>
      <div className="labelWrapper">
        {labelText}
        <span className="labelDescription">{labelDescription}</span>
      </div>
    </label>
  );
}

// The base component for flag (reporting) flows. It should be contained within
// other Flag* components, such as <FlagConversation> or <FlagPin>.
// It does not maintain state for `Flow` or `Status`; that should be maintained
// in the parent component, and modified with Flag.handleFlowStatusChange()
class BlockAndUnfollow extends Component {
  static propTypes = {
    flagType: PropTypes.oneOf(['PIN', 'COMMENT', 'CONVERSATION', 'DID_IT']),
    flagReason: PropTypes.string,
    selectedReason: PropTypes.string,
    detailedReasons: PropTypes.arrayOf(PropTypes.string),
    status: PropTypes.oneOf(['STARTED', 'SELECTED', 'SUBMITTED', 'PROCESSING', 'COMPLETED'])
      .isRequired,
    onClose: PropTypes.func.isRequired,
    onFlowStatusChange: PropTypes.func.isRequired,
    unfollowBoard: PropTypes.func.isRequired,
    unfollowUser: PropTypes.func.isRequired,
    users: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        full_name: PropTypes.string.isRequired,
        explicitly_followed_by_me: PropTypes.bool,
      }),
    ),
    board: PropTypes.shape({
      id: PropTypes.string,
      followed_by_me: PropTypes.bool,
      collaborated_by_me: PropTypes.bool,
    }),
    viewer: PropTypes.shape({
      id: PropTypes.string,
    }).isRequired,
  };

  state = {
    userIdsToBlock: new Set(),

    selectedRadio: null,

    // used to maintain a set of actions (ie, leaveAndUnfollowBoard, leaveBoardAndBlockPinner)
    selectedCheckboxes: new Set(),

    isUnfollowSubflow: false,

    nonSelfUsers: this.props.users.filter(({ id }) => id !== this.props.viewer.id),
  };

  isFollowingBoard = this.props.board && this.props.board.followed_by_me;
  isFollowingPinner = this.props.users[0] && this.props.users[0].explicitly_followed_by_me;
  isBoardCollaboratedByMe = this.props.board && this.props.board.collaborated_by_me;

  handleClose = () => {
    this.props.onClose();
  };

  // Close the confirmation dialog that appears after submitting users to block
  handleCloseUserBlock = () => {
    this.props.onFlowStatusChange({
      status: Status.SELECTED,
    });
  };

  handleFlowStatusChange = (flowState, cb) => {
    this.props.onFlowStatusChange(flowState, cb);
  };

  // Update map of users to block
  handleUpdateUserIdsToBlock = (evt) => {
    const userIdsToBlock = new Set(this.state.userIdsToBlock);

    if (evt.target.checked) {
      userIdsToBlock.add(evt.target.value);
    } else {
      userIdsToBlock.delete(evt.target.value);
    }

    this.setState({
      userIdsToBlock,
    });
    this.handleFlowStatusChange({
      status: userIdsToBlock.size === 0 ? Status.STARTED : Status.SELECTED,
    });
  };

  // update map of actions selected.
  handleCheckboxUpdate = (evt) => {
    const selectedCheckboxes = new Set(this.state.selectedCheckboxes);

    if (evt.target.checked) {
      selectedCheckboxes.add(evt.target.value);
    } else {
      selectedCheckboxes.delete(evt.target.value);
    }

    this.setState({
      selectedCheckboxes,
    });
    this.handleFlowStatusChange({
      status: selectedCheckboxes.size === 0 ? Status.STARTED : Status.SELECTED,
    });
  };

  handleRadioUpdate = (evt) => {
    // Update the userIdsToBlock when the blockPinner radio is selected
    const userIdsToBlock = this.state.userIdsToBlock;

    if (evt.target.value === 'blockPinner') {
      userIdsToBlock.add(this.props.users[0].id);
    } else {
      userIdsToBlock.delete(this.props.users[0].id);
    }

    this.setState(
      {
        selectedRadio: evt.target.value,
        isUnfollowSubflow: evt.target.value.match(/^unfollow/),
        userIdsToBlock,
      },
      () => {
        this.handleFlowStatusChange({
          status: Status.SELECTED,
        });
      },
    );
  };

  // Users have been selected, 'Block' or 'Unfollow' clicked.
  // If it is a follow, update state to show success message
  // If it is a block, update state to show confirmation dialog.
  handleSubmit = () => {
    const userIdsToBlock = this.state.userIdsToBlock;

    let callback = () => {};
    if (this.state.selectedRadio === 'unfollowPinner') {
      callback = this.unfollowPinner;
    } else if (this.state.selectedRadio === 'unfollowBoard') {
      callback = this.unfollowBoard;
    } else if (this.state.selectedCheckboxes.size > 0) {
      if (this.state.selectedCheckboxes.has(Actions.LEAVE_BOARD_AND_BLOCK_PINNER)) {
        // add user to userIdsToBlock, used by handleSubmitUserBlock
        userIdsToBlock.add(this.props.users[0].id);
        // don't leave board in callback, but after user confirms the user block
      }

      if (this.state.selectedCheckboxes.has(Actions.LEAVE_AND_UNFOLLOW_BOARD)) {
        callback = () => Promise.all([this.leaveBoard(), this.unfollowBoard()]);
      }
    }

    this.setState(
      {
        userIdsToBlock,
      },
      () => {
        this.handleFlowStatusChange(
          {
            status: Status.SUBMITTED,
          },
          () => {
            callback();
          },
        );
      },
    );
  };

  unfollowPinner = () => {
    const { unfollowUser } = this.props;
    this.handleFlowStatusChange(
      {
        status: Status.PROCESSING,
      },
      () => {
        unfollowUser(this.props.users[0].id).then(() => {
          this.handleFlowStatusChange({
            status: Status.COMPLETED,
          });
        });
      },
    );
  };

  unfollowBoard = () => {
    const { unfollowBoard } = this.props;
    this.handleFlowStatusChange(
      {
        status: Status.PROCESSING,
      },
      () => {
        unfollowBoard(this.props.board.id).then(() => {
          this.handleFlowStatusChange({
            status: Status.COMPLETED,
          });
        });
      },
    );
  };

  leaveBoard = () => {
    this.handleFlowStatusChange(
      {
        status: Status.PROCESSING,
      },
      () => {
        leaveBoard(this.props.board.id, this.props.viewer.id).then(() => {
          this.handleFlowStatusChange({
            status: Status.COMPLETED,
          });
        });
      },
    );
  };

  // User confirms the Block action
  handleSubmitUserBlock = () => {
    this.handleFlowStatusChange({
      status: Status.PROCESSING,
    });

    // If all the actions are blockUser actions
    return Promise.all(
      Array.from(this.state.userIdsToBlock).map((userId) =>
        // TODO(tuanhuynh/kathy): remove conversation chat head
        blockUser(userId),
      ),
    )
      .then(() => {
        // if leaving the board was contingent upon the user confirming the userBlock modal
        if (this.state.selectedCheckboxes.has(Actions.LEAVE_BOARD_AND_BLOCK_PINNER)) {
          return Promise.all([this.leaveBoard(), this.unfollowBoard()]);
        }
        return undefined;
      })
      .finally(() => {
        this.handleFlowStatusChange({
          status: Status.COMPLETED,
        });
      });
  };

  // Render a checkbox for each user to block
  renderBlockPinnerCheckbox = (user, handler) =>
    renderBlockUnfollowCheckbox({
      id: 'blockPinner' + user.id,
      value: user.id,
      labelText: interpolateNamedTemplate(
        i18n._('Block {{ pinnerName }}', 'form option to block a pinner'),
        {
          pinnerName: user.full_name,
        },
      ),
      labelDescription: i18n._(
        'You won’t be able to send each other messages or interact with each other’s Pins.',
        'explanation of blocking a user',
      ),
      handler,
    });

  renderUnfollowBoardRadio = () =>
    renderBlockUnfollowRadio({
      type: 'unfollowBoard',
      labelText: i18n._('Unfollow this board'),
      labelDescription: i18n._('If you want to stop seeing Pins from this board in your home feed'),
      handleRadioUpdate: this.handleRadioUpdate,
    });

  renderUnfollowPinnerRadio = () => {
    const { users } = this.props;
    return renderBlockUnfollowRadio({
      type: 'unfollowPinner',
      labelText: interpolateNamedTemplate(
        i18n._('Unfollow {{ pinnerName }}', 'form option to unfollow a pinner'),
        {
          pinnerName: users[0].full_name,
        },
      ),
      labelDescription: i18n._('If you want to stop seeing any of their Pins in your home feed'),
      handleRadioUpdate: this.handleRadioUpdate,
    });
  };

  renderBlockPinnerRadio = () => {
    const { users } = this.props;
    return renderBlockUnfollowRadio({
      type: 'blockPinner',
      labelText: interpolateNamedTemplate(
        i18n._('Block {{ pinnerName }}', 'form option to block a pinner'),
        {
          pinnerName: users[0].full_name,
        },
      ),
      labelDescription: i18n._(
        'You won’t be able to follow each other or interact with each other’s Pins',
      ),
      handleRadioUpdate: this.handleRadioUpdate,
    });
  };

  renderLeaveAndUnfollowBoardCheckbox = () =>
    renderBlockUnfollowCheckbox({
      id: Actions.LEAVE_AND_UNFOLLOW_BOARD,
      value: Actions.LEAVE_AND_UNFOLLOW_BOARD,
      labelText: i18n._(
        'Leave and unfollow this group board',
        'form option to leave a group board',
      ),
      labelDescription: i18n._(
        'You won’t be able to Pin to it and you won’t see Pins from it in your home feed',
      ),
      handler: this.handleCheckboxUpdate,
    });

  renderLeaveBoardBlockPinnerCheckbox = () => {
    const { users } = this.props;
    return renderBlockUnfollowCheckbox({
      id: Actions.LEAVE_BOARD_AND_BLOCK_PINNER,
      value: Actions.LEAVE_BOARD_AND_BLOCK_PINNER,
      labelText: interpolateNamedTemplate(
        i18n._(
          'Leave this group board and block {{ pinnerName }}',
          'form option to block a pinner',
        ),
        {
          pinnerName: users[0].full_name,
        },
      ),
      labelDescription: i18n._(
        'You won’t be able to follow each other or interact with each other’s Pins',
      ),
      handler: this.handleCheckboxUpdate,
    });
  };

  renderBlockAndUnfollow = () => {
    const { flagReason, selectedReason, flagType } = this.props;
    const { nonSelfUsers } = this.state;

    // Based on the flag reason & selected reason, an additional message may be displayed.
    let additionalMessage;
    if (selectedReason === 'harassingOther') {
      additionalMessage = interpolateNamedTemplate(
        i18n._(
          'We remove content that identifies and ' +
            'attacks private people because we consider it to be bullying. ' +
            'We also don’t allow content that reveal someone’s personally identifiable information.  ' +
            'Learn more about our ' +
            ' {{ communityGuidelines }}.',
          'confirmation message after reporting harassment',
        ),
        {
          communityGuidelines: (
            <NavigateLink key="policyLink" to={ABOUT_ACCEPTABLE_USE}>
              {i18n._('Community Guidelines', 'link to community guidelines for harassment')}
            </NavigateLink>
          ),
        },
      );
    } else if (selectedReason === 'harassingPublicFigure') {
      additionalMessage = i18n._(
        'Please note that we won’t necessarily take down stuff that attacks public figures.',
        'message shown after reporting harrassment',
      );
    } else if (selectedReason === 'harassingFriend') {
      additionalMessage = i18n._(
        'Before we can review this Pin, we need to hear from the person who’s being ' +
          'harassed. Please have your friend report this Pin to us.',
        'message shown after reporting harrassment',
      );
    } else if (['spam', 'policies', 'hurtfulContent'].includes(flagReason)) {
      additionalMessage = i18n._(
        'We’ll take a look at this Pin and delete it if it goes against our policies.',
        'confirmation message after reporting a pin',
      );
    }

    let blockUnfollowMessage;
    if (this.isFollowingBoard && this.isFollowingPinner) {
      blockUnfollowMessage = i18n._(
        'You can also unfollow or block this person.',
        'description to block or unfollow',
      );
    } else {
      blockUnfollowMessage = i18n.ngettext(
        'You can also block this person.',
        'You can also block these people.',
        nonSelfUsers.length,
        'description to block people',
      );
    }

    let actions = [];
    switch (flagType) {
      case FlagType.PIN:
        if (this.isBoardCollaboratedByMe) {
          actions = [
            this.renderLeaveAndUnfollowBoardCheckbox(),
            this.renderLeaveBoardBlockPinnerCheckbox(),
          ];
        } else {
          if (this.isFollowingBoard) {
            actions.push(this.renderUnfollowBoardRadio());
          }
          if (this.isFollowingPinner) {
            actions.push(this.renderUnfollowPinnerRadio());
          }

          actions.push(this.renderBlockPinnerRadio());
        }
        break;
      case FlagType.CONVERSATION:
        actions = nonSelfUsers.map((user) =>
          this.renderBlockPinnerCheckbox(user, this.handleUpdateUserIdsToBlock),
        );
        break;
      case FlagType.DID_IT:
        actions = nonSelfUsers.map((user) =>
          this.renderBlockPinnerCheckbox(user, this.handleUpdateUserIdsToBlock),
        );
        break;
      case FlagType.COMMENT:
        actions = nonSelfUsers.map((user) =>
          this.renderBlockPinnerCheckbox(user, this.handleUpdateUserIdsToBlock),
        );
        break;
      default:
        break;
    }

    return (
      <div className="blockAndUnfollowFormContent">
        <div className="modalDescription">
          {additionalMessage ? (
            <div>
              {additionalMessage}
              <br />
              <br />
            </div>
          ) : null}
          {blockUnfollowMessage}
        </div>
        {actions}
      </div>
    );
  };

  renderTitle = () => {
    const { status, users, detailedReasons, flagType } = this.props;

    const { selectedCheckboxes, selectedRadio, userIdsToBlock } = this.state;

    switch (flagType) {
      case FlagType.CONVERSATION:
        if (status === Status.COMPLETED) {
          const usersToBlock = users.filter((user) => this.state.userIdsToBlock.has(user.id));
          return interpolateNamedTemplate(
            i18n._('You’ve blocked {{usernames}}', 'title of modal after user has been blocked'),
            {
              usernames: listItemsAnd(getUserNames(usersToBlock)),
            },
          );
        } else {
          return i18n._('Thanks for your report', 'title at end of report flow');
        }

      case FlagType.PIN:
        if (status === Status.COMPLETED) {
          if (selectedRadio === 'unfollowBoard') {
            return i18n._('You’ve unfollowed this board', 'title confirming board unfollow');
          } else if (selectedRadio === 'unfollowPinner') {
            return interpolateNamedTemplate(
              i18n._('You’ve unfollowed {{ pinnerName }}', 'title confirming user unfollow'),
              {
                pinnerName: users[0].full_name,
              },
            );
          } else if (userIdsToBlock.size > 0) {
            const usersToBlock = users.filter((user) => userIdsToBlock.has(user.id));
            return interpolateNamedTemplate(
              i18n._('You’ve blocked {{usernames}}', 'title of modal after user has been blocked'),
              {
                usernames: listItemsAnd(getUserNames(usersToBlock)),
              },
            );
          } else if (selectedCheckboxes.size > 0) {
            return i18n._(
              'You’ve left and unfollowed this board',
              'title confirming board leave & unfollow',
            );
          }
        } else {
          const isReportingPin =
            intersection(detailedReasons, [
              'nudity',
              'spam',
              'hate-speech',
              'self-harm',
              'harassingMeOrMyChild',
              'harassingMeOrAFriend',
              'gore',
            ]).length > 0;

          if (isReportingPin) {
            return i18n._('Thanks for your report', 'title at end of report flow');
          } else if (this.boardCollaboratedByMe) {
            return i18n._('Leave this board or block this person?');
          } else if (this.isFollowingBoard || this.isFollowingPinner) {
            return i18n._('Unfollow or block this person?');
          } else {
            return i18n._('Block this person?');
          }
        }
        break;
      default:
        break;
    }
    return undefined;
  };

  renderCompletionMessage = () => {
    const { users } = this.props;
    const { selectedRadio, userIdsToBlock, selectedCheckboxes } = this.state;

    let message;

    if (selectedRadio === 'unfollowBoard') {
      message = i18n._(
        'You won’t see Pins from this board in your home feed anymore.',
        'message describing what unfollowing a board means',
      );
    } else if (selectedRadio === 'unfollowPinner') {
      message = interpolateNamedTemplate(
        i18n._(
          'You won’t see {{ username }} Pins in your home feed anymore.',
          'message describing what unfollowing a pinner means',
        ),
        {
          username: users[0].full_name,
        },
      );
    } else if (userIdsToBlock.size > 0) {
      // pinner blocked
      message = i18n._(
        'You won’t be able to follow each other or interact with each other’s pins.',
        'message describing what blocking means',
      );
    } else if (selectedCheckboxes.size > 0) {
      message = i18n._(
        'You won’t be able to save Pins to this board or see its Pins in your home feed anymore.',
        'message describing leave/unfollow board',
      );
    }

    return <span key="blockingConfirmation">{message}</span>;
  };

  renderPolicyLink = () => {
    const { status } = this.props;

    // Shown after initial reporting flow is submitted, when user sees the BlockAndUnfollow component
    if (status !== Status.COMPLETED) {
      return (
        <p className="helpText">
          {interpolateNamedTemplate(
            i18n._('Learn more about {{ linkToTopic }}', 'footer link to learn more about a topic'),
            {
              linkToTopic: (
                <NavigateLink key="policyLink" to={HELP_BLOCKING_URL}>
                  {i18n._('blocking', 'footer link to learn more about blocking')}
                </NavigateLink>
              ),
            },
          )}
        </p>
      );
    }
    return undefined;
  };

  render() {
    const { status } = this.props;
    const { isUnfollowSubflow, selectedCheckboxes, nonSelfUsers } = this.state;

    // Form footer: primary action
    let primaryAction;

    if ([Status.STARTED, Status.COMPLETED].includes(status)) {
      primaryAction = (
        <LegacyButton
          className={cx('doneButton', 'visible')}
          onClick={this.handleClose}
          style={{ display: 'block' }}
          text={i18n._('Done', 'confirm reporting flow is done & close modal')}
          type="primary"
        />
      );
    } else {
      let primaryActionText;

      if (selectedCheckboxes.size > 0) {
        primaryActionText = i18n._('Leave', 'submit button');
      } else if (this.state.isUnfollowSubflow) {
        primaryActionText = i18n._('Unfollow', 'submit board/user to unfollow');
      } else {
        primaryActionText = i18n._('Block', 'submit users to block');
      }

      primaryAction = (
        <LegacyButton
          className={cx('blockButton', 'visible')}
          onClick={this.handleSubmit}
          loading={[Status.SUBMITTED, Status.PROCESSING].includes(status)}
          text={primaryActionText}
          type="primary"
        />
      );
    }

    // TODO how do we determine Block confirm modal classnames
    return (
      <form
        className={cx({
          standardForm: true,
          BlockAndUnfollowForm: status !== Status.COMPLETED,
          ConfirmDialog: status === Status.COMPLETED,
          fluid: status === Status.COMPLETED,
        })}
        method="post"
      >
        <h1>{this.renderTitle()}</h1>
        <div
          className={cx('flagContent', {
            modalActionDescription: status === Status.COMPLETED,
          })}
        >
          {status !== Status.COMPLETED
            ? this.renderBlockAndUnfollow()
            : this.renderCompletionMessage()}
        </div>
        <div className="formFooter">
          {this.renderPolicyLink()}
          <div className="formFooterButtons">{primaryAction}</div>
        </div>

        {[Status.SUBMITTED, Status.PROCESSING].includes(status) &&
        (!isUnfollowSubflow || selectedCheckboxes.has(Actions.LEAVE_BOARD_AND_BLOCK_PINNER)) ? (
          <LegacyModal className={cx('UserBlock')} onHide={this.handleCloseUserBlock}>
            <UserBlock
              isLoading={status === Status.PROCESSING}
              onClose={this.handleCloseUserBlock}
              onSubmit={this.handleSubmitUserBlock}
              users={nonSelfUsers}
            />
          </LegacyModal>
        ) : null}
      </form>
    );
  }
}

const mapStateToProps = (state, props) => ({
  viewer: state.viewer,
});

const mapDispatchToProps = (dispatch) => ({
  unfollowBoard: (boardId) => dispatch(unfollowBoard(boardId)),
  unfollowUser: (userId) => dispatch(unfollowUser(userId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BlockAndUnfollow);
